import { Action } from 'history';
import React, { useState } from 'react';

import { PackTestEvaluationResponse } from '../../services/types';
import { MappingState } from '../shared/types';
import PackCalculatorMapping, { AttributeModelRef } from './PackCalculatorMapping';

type BatchLoadingPackCalculatorMappingsProps = {
  mappings: MappingState[];
  setRefs: React.Dispatch<React.SetStateAction<Record<string, AttributeModelRef | null>>>;
  dispatch: React.Dispatch<Action>;
  testResult?: PackTestEvaluationResponse;
  resetEvaluation: () => void;
};

const BatchLoadingPackCalculatorMappings = ({
  mappings,
  setRefs,
  dispatch,
  testResult,
  resetEvaluation,
}: BatchLoadingPackCalculatorMappingsProps) => {
  const batchSize = 100;
  const [mappingsLoaded, setMappingsLoaded] = useState<Set<String>>(new Set());

  return (
    <>
      {mappings.slice(0, mappingsLoaded.size + batchSize).map((mapping: MappingState) => (
        <PackCalculatorMapping
          key={mapping.id}
          id={mapping.id}
          setRefs={setRefs}
          dispatch={dispatch}
          mapping={mapping}
          evaluationResult={mapping.id === testResult?.key ? testResult : undefined}
          resetEvaluation={resetEvaluation}
          mappingsLoaded={mappingsLoaded}
          setMappingsLoaded={setMappingsLoaded}
        />
      ))}
    </>
  );
};

export default BatchLoadingPackCalculatorMappings;
